import { AutomatonRule, CellKind, Condition } from './types'

export function getRandomNonEmptyNodeKind(): CellKind {
  return (Math.round(Math.random() * 3) + 1) as CellKind
}

export function getRandomNodeKind(): CellKind {
  return Math.round(Math.random() * 4) as CellKind
}

export function generateRandomAutomataRules(): AutomatonRule[] {
  const result: AutomatonRule[] = []
  const ruleCount = Math.round(Math.random() * 12) + 3

  for (let i = 0; i < ruleCount; i++) {
    const conditionCount = Math.round(Math.random() * 3) + 1
    const conditions: Condition[] = []
    for (let j = 0; j < conditionCount; j++) {
      const x = Math.round(Math.random() * 4) - 2
      const y = Math.round(Math.random() * 4) - 2
      conditions.push({
        n: [x, y],
        value: getRandomNonEmptyNodeKind()
      })
    }
    result.push({ conditions, result: getRandomNonEmptyNodeKind() })
  }
  return result
}
